<script setup lang="ts">
import { useFilingStore } from '@/modules/filing/stores/filing-store'
import { ref } from 'vue'
import { VButton, ActionItem } from '@/modules/shared/components'

const filingStore = useFilingStore()

const props = defineProps<{
  currentFolder: Folder | null
  handleToggleExpand: () => Promise<void>
  isExpanded: boolean
  as?: 'button' | 'action'
}>()

const fileInput = ref<HTMLInputElement | null>(null)
const isUploading = ref(false)

const handleUpload = async (event: Event) => {
  const input = event.target as HTMLInputElement
  if (!input.files?.length) return

  isUploading.value = true
  try {
    for (const file of input.files) {
      await filingStore.addFile(
        file,
        props.currentFolder?.id,
        props.currentFolder?.fileable_id,
        props.currentFolder?.fileable_type,
      )
    }
  } catch (error) {
    console.error('File upload failed:', error)
  } finally {
    !props.isExpanded && (await props.handleToggleExpand())
    isUploading.value = false
    input.value = ''
  }
}

const openFileDialog = () => {
  fileInput.value?.click()
}
</script>

<template>
  <div>
    <VButton v-if="as === 'button'" @click="openFileDialog" :loading="isUploading" class="mt-1"> Upload Files </VButton>

    <ActionItem v-else :text="'Upload Files'" @click="openFileDialog" :loading="isUploading" />

    <input type="file" ref="fileInput" class="hidden" multiple @change="handleUpload" />
  </div>
</template>
